{
    "54Ft8": {
        "position": {
            "x": 6,
            "y": 5,
            "z": 1
        },
        "templateKey": "jobs/ember/torch",
        "jobKey": "book/terrain",
        "key": "54Ft8"
    },
    "xtgor": {
        "position": {
            "x": 5,
            "y": 5,
            "z": 1
        },
        "stack": -1,
        "templateKey": "tree",
        "type": "zone",
        "role": "tree",
        "properties": [
            "no healthbar"
        ],
        "imageKey": "book/mess",
        "spriteSize": "contained",
        "key": "xtgor",
        "previousMultiselect": [
            "xtgor",
            "P7qro"
        ]
    },
    "3RCv_": {
        "position": {
            "x": 6,
            "y": 6,
            "z": 1
        },
        "stack": -1,
        "templateKey": "tree",
        "type": "zone",
        "role": "tree",
        "properties": [
            "no healthbar"
        ],
        "imageKey": "book/mess",
        "spriteSize": "contained",
        "key": "3RCv_",
        "previousMultiselect": [
            "xtgor",
            "xtgor",
            "xtgor",
            "3RCv_",
            "3RCv_",
            "RU5ez",
            "RU5ez"
        ]
    },
    "RU5ez": {
        "position": {
            "x": 7,
            "y": 5,
            "z": 1
        },
        "stack": -1,
        "templateKey": "tree",
        "type": "zone",
        "role": "tree",
        "properties": [
            "no healthbar"
        ],
        "imageKey": "book/mess",
        "spriteSize": "contained",
        "key": "RU5ez",
        "previousMultiselect": [
            "xtgor",
            "xtgor",
            "xtgor",
            "3RCv_",
            "3RCv_",
            "RU5ez",
            "RU5ez"
        ]
    },
    "TdaTp": {
        "position": {
            "x": 6,
            "y": 4,
            "z": 1
        },
        "stack": -1,
        "templateKey": "tree",
        "type": "zone",
        "role": "tree",
        "properties": [
            "no healthbar"
        ],
        "imageKey": "book/mess",
        "spriteSize": "contained",
        "key": "TdaTp",
        "previousMultiselect": [
            "xtgor",
            "xtgor",
            "3RCv_",
            "3RCv_",
            "RU5ez",
            "RU5ez"
        ]
    },
    "P7qro": {
        "position": {
            "x": 3,
            "y": 4,
            "z": 1
        },
        "templateKey": "jobs/ember/torch",
        "jobKey": "book/terrain",
        "key": "P7qro",
        "previousMultiselect": [
            "xtgor",
            "P7qro"
        ]
    },
    "LwdYB": {
        "position": {
            "x": 7,
            "y": 3,
            "z": 1
        },
        "templateKey": "jobs/ember/torch",
        "jobKey": "book/terrain",
        "key": "LwdYB"
    },
    "DZQgc": {
        "position": {
            "x": 10,
            "y": 4,
            "z": 1
        },
        "templateKey": "jobs/ember/torch",
        "jobKey": "book/terrain",
        "key": "DZQgc"
    },
    "z-1Ba": {
        "position": {
            "x": 9,
            "y": 7,
            "z": 1
        },
        "templateKey": "jobs/ember/torch",
        "jobKey": "book/terrain",
        "key": "z-1Ba"
    },
    "Wbu4H": {
        "position": {
            "x": 7,
            "y": 8,
            "z": 1
        },
        "templateKey": "jobs/ember/torch",
        "jobKey": "book/terrain",
        "key": "Wbu4H"
    },
    "wh0Cu": {
        "position": {
            "x": 4,
            "y": 8,
            "z": 1
        },
        "templateKey": "jobs/ember/torch",
        "jobKey": "book/terrain",
        "key": "wh0Cu"
    },
    "CZktf": {
        "position": {
            "x": 1,
            "y": 6,
            "z": 1
        },
        "templateKey": "jobs/ember/torch",
        "jobKey": "book/terrain",
        "key": "CZktf"
    },
    "uoib2": {
        "position": {
            "x": 4,
            "y": 7,
            "z": 1
        },
        "stack": -1,
        "templateKey": "tree",
        "type": "zone",
        "role": "tree",
        "properties": [
            "no healthbar"
        ],
        "imageKey": "book/mess",
        "spriteSize": "contained",
        "key": "uoib2",
        "previousMultiselect": [
            "xtgor",
            "xtgor",
            "xtgor",
            "3RCv_",
            "3RCv_",
            "RU5ez",
            "RU5ez"
        ]
    },
    "pYqIR": {
        "position": {
            "x": 4,
            "y": 3,
            "z": 1
        },
        "stack": -1,
        "templateKey": "tree",
        "type": "zone",
        "role": "tree",
        "properties": [
            "no healthbar"
        ],
        "imageKey": "book/mess",
        "spriteSize": "contained",
        "key": "pYqIR",
        "previousMultiselect": [
            "xtgor",
            "P7qro"
        ]
    }
}